import * as React from "react";

function Unblock(props) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.57538 18.4246C4.55039 19.3996 5.70791 20.1731 6.98182 20.7007C8.25574 21.2284 9.62112 21.5 11 21.5C12.3789 21.5 13.7443 21.2284 15.0182 20.7007C16.2921 20.1731 17.4496 19.3996 18.4246 18.4246C19.3996 17.4496 20.1731 16.2921 20.7007 15.0182C21.2284 13.7443 21.5 12.3789 21.5 11C21.5 9.62112 21.2284 8.25574 20.7007 6.98182C20.1731 5.70791 19.3996 4.55039 18.4246 3.57538C16.4555 1.60625 13.7848 0.5 11 0.5C8.21523 0.5 5.54451 1.60625 3.57538 3.57538C1.60625 5.54451 0.5 8.21523 0.5 11C0.5 13.7848 1.60625 16.4555 3.57538 18.4246ZM6.1082 17.5415C7.68114 18.7187 9.62572 19.2896 11.5854 19.1493C13.5451 19.009 15.3886 18.1671 16.7778 16.7778C18.1671 15.3886 19.009 13.5451 19.1493 11.5854C19.2896 9.62572 18.7187 7.68114 17.5415 6.1082L14.2993 9.35034C14.0793 9.56286 13.7846 9.68045 13.4787 9.67779C13.1728 9.67514 12.8802 9.55244 12.6639 9.33613C12.4476 9.11982 12.3249 8.82721 12.3222 8.52132C12.3195 8.21542 12.4371 7.92072 12.6497 7.70069L15.8906 4.45854C14.3173 3.28443 12.3739 2.71615 10.4159 2.8577C8.45787 2.99925 6.61633 3.84117 5.22827 5.22936C3.84022 6.61756 2.99849 8.45918 2.85714 10.4172C2.71579 12.3752 3.28427 14.3186 4.45854 15.8918L7.70069 12.6497C7.92072 12.4371 8.21542 12.3195 8.52132 12.3222C8.82721 12.3249 9.11982 12.4476 9.33613 12.6639C9.55244 12.8802 9.67514 13.1728 9.67779 13.4787C9.68045 13.7846 9.56286 14.0793 9.35034 14.2993L6.1082 17.5415Z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoUnblock = React.memo(Unblock);
export default MemoUnblock;
